import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class ButtonDisabled extends BaseOption {
  static userInterfaceComponent = {
    label: "Disabled",
    component: inspectorTools.RADIO_BAR,
    props: {
      iconSize: 24,
      options: [
        { label: "No", value: false },
        { label: "Yes", value: true },
      ],
    },
  };

  static defaultValue = false;
}
